module.exports = __webpack_public_path__ + "img/English.6e5d5779.svg";